module.exports = __webpack_public_path__ + "img/police_resource.ae9a72ec.jpeg";